import { FC, lazy, useMemo } from 'react';
import { SurrendersParams } from 'src/apis/monolith/types';
import { PageSpinner } from 'src/components/spinner-container';
import { usePageParams } from 'src/pages/reporting/surrender/overview/use-page-params';
import { useSurrenders } from 'src/pages/reporting/surrender/overview/use-surrenders';
import {
  PlatformSettings,
  usePlatformSettings,
} from 'src/pages/reporting/use-platform-settings';

const Page = lazy(() => import('./page'));

export const SurrenderOverview: FC = () => {
  const platformSettings = usePlatformSettings();

  if (!platformSettings.loaded) return <PageSpinner />;

  return (
    <LoadData platformSettings={platformSettings.response?.data ?? null} />
  );
};

const LoadData: FC<{ platformSettings: PlatformSettings | null }> = ({
  platformSettings,
}) => {
  const pageParams = usePageParams({ platformSettings });

  const params = useMemo(
    () =>
      ({
        start: pageParams.value.start,
        pageSize: pageParams.value.pageSize,
        sortColumn: pageParams.value.sortColumn,
        sortAscending: pageParams.value.sortAscending,
        favoritesOnly: pageParams.value.favoritesOnly,
        dealIds: pageParams.value.dealId,
        runtimeFrom: pageParams.value.runtimeFrom,
        runtimeTo: pageParams.value.runtimeTo,
        direction: pageParams.value.direction,
        tso: pageParams.value.tso.map((tso) => tso.value),
        networkPointName: pageParams.value.networkPointName,
        'bookedCapacity-min': pageParams.value['bookedCapacity-min'],
        'bookedCapacity-max': pageParams.value['bookedCapacity-max'],
        amountSetting: pageParams.value.amountSetting,
        costSetting: pageParams.value.costSetting,
      }) satisfies SurrendersParams,
    [pageParams.value]
  );
  const surrenders = useSurrenders({ params });

  if (!surrenders.response) return <PageSpinner />;

  return <Page pageParams={pageParams} surrenders={surrenders} />;
};
